(() => {
  const KEY = 'wishlist:handles';

  const getList = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  };
  const setList = (arr) => localStorage.setItem(KEY, JSON.stringify([...new Set(arr)]));

  const isSaved = (handle) => getList().includes(handle);
  const toggle = (handle) => {
    const list = getList();
    if (isSaved(handle)) setList(list.filter(h => h !== handle));
    else setList([...list, handle]);
    document.dispatchEvent(new CustomEvent('wishlist:changed'));
  };

  const syncButtons = () => {
    const list = getList();
    document.querySelectorAll('.wishlist-button[data-product-handle]').forEach(btn => {
      const handle = btn.getAttribute('data-product-handle');
      const active = list.includes(handle);
      btn.classList.toggle('active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.title = active ? 'Retirer des favoris' : 'Ajouter aux favoris';
    });
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wishlist-button[data-product-handle]');
    if (!btn) return;
    e.preventDefault();
    toggle(btn.getAttribute('data-product-handle'));
    syncButtons();
  });

  document.addEventListener('wishlist:changed', syncButtons);
  document.addEventListener('DOMContentLoaded', syncButtons);

  // Expose API minimal pour la page /favorites
  window.Wishlist = { getList, setList };
})();
